import { render, staticRenderFns } from "./DownloadBtn.vue?vue&type=template&id=7829422c&scoped=true&"
import script from "./DownloadBtn.vue?vue&type=script&lang=js&"
export * from "./DownloadBtn.vue?vue&type=script&lang=js&"
import style0 from "./DownloadBtn.vue?vue&type=style&index=0&id=7829422c&prod&lang=scss&"
import style1 from "./DownloadBtn.vue?vue&type=style&index=1&id=7829422c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7829422c",
  null
  
)

export default component.exports